export const TEAM_EVENTS = {
  TEAM_PREFIX_REDIRECT_CALLED: `route_guard:team_prefix_redirect_called` as const,
} as const;
